import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const AlertIcon24 = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M10.7082 2.60103C11.0996 2.37121 11.5456 2.25 12 2.25C12.4544 2.25 12.9004 2.37121 13.2918 2.60103C13.6832 2.83084 14.0056 3.16088 14.2256 3.55682L21.787 17.2051C22.0094 17.5906 22.126 18.0277 22.125 18.4724C22.124 18.919 22.0045 19.3574 21.7785 19.7432C21.5526 20.129 21.2282 20.4484 20.8384 20.6691C20.4493 20.8894 20.0088 21.0035 19.5613 20.9999H4.43874C3.99124 21.0035 3.55071 20.8894 3.16164 20.6691C2.77178 20.4484 2.44744 20.129 2.22148 19.7432C1.99553 19.3574 1.876 18.919 1.87501 18.4724C1.87402 18.0277 1.99059 17.5906 2.21295 17.2051L9.77441 3.55682C9.99437 3.16088 10.3168 2.83084 10.7082 2.60103ZM12 3.36214C11.7451 3.36214 11.4949 3.43013 11.2753 3.55906C11.0558 3.68798 10.8749 3.87312 10.7515 4.09523L3.18821 17.7468L3.18287 17.7562C3.05708 17.9732 2.99112 18.2194 2.99168 18.4699C2.99223 18.7205 3.05929 18.9664 3.18604 19.1828C3.3128 19.3992 3.49474 19.5784 3.71344 19.7022C3.93215 19.826 4.17982 19.8901 4.43137 19.8878L4.4364 19.8878L19.5686 19.8878C19.8202 19.89 20.0679 19.826 20.2866 19.7022C20.5053 19.5784 20.6872 19.3992 20.814 19.1828C20.9407 18.9664 21.0078 18.7205 21.0083 18.4699C21.0089 18.2194 20.9429 17.9732 20.8171 17.7562L20.8118 17.7468L13.2485 4.09523C13.1251 3.87312 12.9442 3.68798 12.7247 3.55906C12.5051 3.43013 12.2549 3.36214 12 3.36214ZM12 8.02497C12.3084 8.02497 12.5583 8.27393 12.5583 8.58104V12.5353C12.5583 12.8424 12.3084 13.0914 12 13.0914C11.6916 13.0914 11.4417 12.8424 11.4417 12.5353V8.58104C11.4417 8.27393 11.6916 8.02497 12 8.02497Z'
    fill='#A82636'
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M11.2254 16.4899C11.2254 16.0906 11.5504 15.767 11.9512 15.767H12.0505C12.4514 15.767 12.7763 16.0906 12.7763 16.4899C12.7763 16.8891 12.4514 17.2128 12.0505 17.2128H11.9512C11.5504 17.2128 11.2254 16.8891 11.2254 16.4899Z'
    fill='#A82636'
  />
</Svg>;

export default AlertIcon24;
